const  i18nmessages =  {
    en: {},
    hu: {},
    ro: {}
  }
export default i18nmessages;
  